import NextLink from "next/link";
import { ComponentPropsWithoutRef, forwardRef } from "react";

type LinkProps = ComponentPropsWithoutRef<typeof NextLink>;

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ prefetch = false, ...props }, ref) => {
    return <NextLink ref={ref} prefetch={prefetch} {...props} />;
  }
);

Link.displayName = "Link";

export default Link;
